module.exports = __webpack_public_path__ + "img/23_20.068baeee.png";